module.exports = __webpack_public_path__ + "static/media/qgcmapping.985fff40.avif";